export type CompareSlotState = {
  id: string;
  sessionId: string;
  lapNumber: number | null;
};

export function createCompareSlot(sessionId: string): CompareSlotState {
  return {
    id: `${sessionId}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    sessionId,
    lapNumber: null,
  };
}

export function reconcileSessionSelection({
  sessionIds,
  previousPrimarySessionId,
  previousPrimaryLapNumber,
  compareSlots,
}: {
  sessionIds: string[];
  previousPrimarySessionId: string | null;
  previousPrimaryLapNumber: number | null;
  compareSlots: CompareSlotState[];
}) {
  const [primarySessionId, ...comparisonSessionIds] = [...new Set(sessionIds)];
  if (!primarySessionId) return null;

  const primaryChanged = primarySessionId !== previousPrimarySessionId;
  const promotedSlots = primaryChanged
    ? compareSlots.filter((slot) => slot.sessionId === primarySessionId)
    : [];
  const [promotedSlot, ...remainingPromotedSlots] = promotedSlots;
  const retainedPrimaryComparisons = primaryChanged
    ? remainingPromotedSlots
    : compareSlots.filter((slot) => slot.sessionId === primarySessionId);

  const nextCompareSlots = [...retainedPrimaryComparisons];
  for (const sessionId of comparisonSessionIds) {
    const existingSlots = compareSlots.filter((slot) => slot.sessionId === sessionId);
    if (primaryChanged && sessionId === previousPrimarySessionId) {
      nextCompareSlots.push(
        { ...createCompareSlot(sessionId), lapNumber: previousPrimaryLapNumber },
        ...existingSlots,
      );
    } else if (existingSlots.length > 0) {
      nextCompareSlots.push(...existingSlots);
    } else {
      nextCompareSlots.push(createCompareSlot(sessionId));
    }
  }

  return {
    primarySessionId,
    primaryLapNumber: primaryChanged ? promotedSlot?.lapNumber ?? null : previousPrimaryLapNumber,
    compareSlots: nextCompareSlots,
  };
}
